import {
  SET_REPAIR_SERVICES,
  CLEAR_SERVICES,
  ADD_REPAIR_NOTES
} from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.repair, { type, payload }) {
  switch (type) {
    case SET_REPAIR_SERVICES:
      return payload;
    case ADD_REPAIR_NOTES:
      return state.map(service => {
        if (service.id === payload.serviceId) {
          return { ...service, notes: payload.notes };
        } else {
          return service;
        }
      });
    case CLEAR_SERVICES:
    case RESET_APP_STATE:
      return initialState.repair;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/repair/reducer.js